import YouTubeIcon from 'root/src/client/public/icons/ic-youtube-colorized.svg';
import TwitchIcon from 'root/src/client/public/icons/ic-twitch-colorized.svg';
import { Platform } from 'root/src/shared/@types/platforms';
import { giveawaysQueryKeys } from 'root/src/shared/giveaways/giveaways.keys';
export var GiveawayTab;
(function (GiveawayTab) {
    GiveawayTab["GiveawayWinners"] = "GIVEAWAY_WINNERS";
    GiveawayTab["GiveawayGrowth"] = "GIVEAWAY_GROWTH";
})(GiveawayTab || (GiveawayTab = {}));
export const giveawayTabId = 'tab';
export const giveawayPlatformIconMap = {
    [Platform.YouTube]: YouTubeIcon,
    [Platform.Twitch]: TwitchIcon,
};
export const tabOptions = [
    {
        id: GiveawayTab.GiveawayWinners,
        label: 'Giveaway winners',
    },
    {
        id: GiveawayTab.GiveawayGrowth,
        label: 'Growth stats',
    },
];
export const growthOptions = [
    {
        icon: YouTubeIcon,
        label: 'New subscribers',
        platform: Platform.YouTube,
    },
    {
        icon: TwitchIcon,
        label: 'New followers',
        platform: Platform.Twitch,
    },
];
export const GIVEAWAYS_INITIAL_PAGE = 0;
export const GIVEAWAYS_DEFAULT_LIMIT = 50;
export const GET_GIVEAWAYS_PAGED_BASE_QUERY_PARAMS = {
    staleTime: 30000,
    initialPageParam: GIVEAWAYS_INITIAL_PAGE,
    getNextPageParam: (lastPage) => {
        const allPages = Math.ceil(lastPage.total / lastPage.limit);
        const currentPage = Math.floor(lastPage.offset / lastPage.limit);
        const nextPage = currentPage + 1;
        const hasNext = nextPage < allPages;
        if (!hasNext) {
            return undefined;
        }
        return nextPage;
    },
    queryKey: giveawaysQueryKeys.giveawaysPagedQueryKeySelector(),
};
export const GET_VOUCHERS_COUNT_BASE_PARAMS = {
    staleTime: 30000,
    queryKey: giveawaysQueryKeys.giveawaysVouchersCount(),
};
